import { render, staticRenderFns } from "./MyShares.vue?vue&type=template&id=71fdb1e5&scoped=true&"
import script from "./MyShares.vue?vue&type=script&lang=js&"
export * from "./MyShares.vue?vue&type=script&lang=js&"
import style0 from "./MyShares.vue?vue&type=style&index=0&id=71fdb1e5&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fdb1e5",
  null
  
)

export default component.exports